module.exports = __webpack_public_path__ + "public/Icons/storeAdminIcon.png?2bfc70b2";